import { Dispatch, SetStateAction, useRef } from 'react'
import buttonStyles from '../Buttons.module.css'
import pivotStyles from '../PivotButton/PivotButton.module.css'
import styles from './MenuButton.module.css'
import {
  Menu,
  MenuList,
  MenuItem,
  MenuPopover,
  MenuTrigger,
  Button,
} from '@fluentui/react-components'

export interface MenuItemProps {
  key: string
  text: string
  onClick?: () => void
  disabled?: boolean
}

interface MenuButtonProps {
  showMenu: boolean
  setShowMenu: Dispatch<SetStateAction<boolean>>
  menuItems: MenuItemProps[]
  text: string
  modal?: JSX.Element
  disabledMenu?: boolean
}

const MenuButton = ({
  showMenu,
  setShowMenu,
  menuItems,
  text,
  modal,
  disabledMenu,
}: MenuButtonProps) => {
  const buttonRef = useRef(null)

  return (
    <div>
      <Menu open={showMenu} onOpenChange={(e, data) => setShowMenu(data.open)}>
        <MenuTrigger disableButtonEnhancement>
          <Button
            ref={buttonRef}
            className={`${buttonStyles.actionButton} ${
              buttonStyles.defaultButton
            } ${showMenu ? pivotStyles.pivotButton : ''}`}
            disabled={disabledMenu}
            onClick={() => setShowMenu(true)}
          >
            {text}
          </Button>
        </MenuTrigger>
        <MenuPopover className={styles.menuPopover}>
          <MenuList className={styles.menuList}>
            {menuItems.map((item) => (
              <MenuItem
                key={item.key}
                disabled={item.disabled}
                onClick={() => {
                  if (item.onClick) {
                    item.onClick()
                  }
                  setShowMenu(false)
                }}
                className={styles.menuItem}
              >
                {item.text}
              </MenuItem>
            ))}
          </MenuList>
        </MenuPopover>
      </Menu>

      {modal}
    </div>
  )
}

export default MenuButton
